























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { email, maxLength, minLength, minValue, required } from 'vuelidate/lib/validators';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest } from '@/types/request';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import { CommonUtils } from '@/util/commonUtils';
import { MapUtils } from '@/util/mapUtils';
import MessageBox from '@/components/MessageBox.vue';
import { Fare, Language } from '@/types/entity';
import { DateUtils } from '@/util/dateUtils';
import moment from 'moment-timezone';
import CreditCardForm from '../../components/CreditCardForm.vue';
// tslint:disable-next-line: no-var-requires
const TimeZones = require('../../config/privatePayTimezones.json');
import FareDetails from '../../components/FareDetails.vue';
import { MathUtils } from '@/util/mathUtils';
declare var google: any;
import StripeCardPayment from '@/components/StripeCardPayment.vue';
import posthog from 'posthog-js';

@Component({
  components: {
    MessageBox,
    CreditCardForm,
    FareDetails,
    StripeCardPayment,
  },
  mixins: [validationMixin],
  data() {
    return {
      phone: '',
      fullName: '',
      email: '',
      selected: null,
      passengerName: '',
      passengerPhone: '',
      confirmPassengerPhone: '',
      selectedService: '',
      vehicleType: '',
      preferredLanguage: '',
      pickupAddress: {
        fullAddress: '',
        originalGoogleAddress: '',
        apartment: '',
        pickUpInstructions: '',
      },
      dropoffAddress: {
        fullAddress: '',
        apartment: '',
        dropOffInstructions: '',
        originalGoogleAddress: '',
      },
      facilityAddress: {
        fullAddress: '',
        originalGoogleAddress: '',
      },
      isPickupSelectedFromGoogle: false,
      isDropoffSelectedFromGoogle: false,
      isFacilityAddressFromGoogle: false,
      tripType: '',
      appointmentDuration: '',
      durationOptions: {
        30: '30 minutes',
        60: '1 hour',
        90: '1 hour and 30 minutes',
        120: '2 hours',
        150: '2 hours and 30 minutes',
        180: '3 hours',
        210: '3 hours and 30 minutes',
        240: '4 hours',
        270: '4 hours and 30 minutes',
        300: '5 hours',
        330: '5 hours and 30 minutes',
        360: '6 hours',
        390: '6 hours and 30 minutes',
        420: '7 hours',
        450: '7 hours and 30 minutes',
        480: '8 hours',
        999: 'Greater than 8 hours',
      },
      waitInLobby: null,
      startDate: null,
      startTime: null,
      startTimeTouched: false,
      legBStartTime: null,
      legBStartTimeTouched: false,
      minDate: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      minTime: new Date(Date.now() + 24 * 60 * 60 * 1000).toTimeString().split(' ')[0],
      interpretationMode: '',
      selectedInterpretationMode: '',
      additionalNotes: '',
      languageOptions: [],

      patientNeedsAssistance: null, // true/false
      willingToOptInRideshare: null, // true/false
      customerHasOwnWheelchair: null, // true/false
      patient: {
        patientHeight: {
          feet: '',
          inch: '',
        },
        patientWeight: '',
      },

      isBariatric: false, // optionally calculated based on height & weight
      isWithCaregiver: null,
      wantsTransporterCaregiver: null,
      showDetails: [],
      underAnesthesia: null,
      additionalPassengers: '',
      additionalConsiderations: [],
      additionalConsiderationsOptions: [
        'Has an oxygen tank or other heavy medical equipment',
        'Is traveling in a motorized wheelchair or scooter',
        'Has dementia or any cognitive impairments',
        // tslint:disable-next-line:max-line-length
        'Been acknowledged as “at-risk” or a “danger to self or others” by a medical professional within the last month',
      ],
      mentalHealth: null,
      isLegBTimeValid: true,
      promoCode: '',
      isPromoCodeApplied: false,
    };
  },
  watch: {
    step(newStep, oldStep) {
      const privatePayRequestSubmission = this as PrivatePayRequestSubmission;
      if (newStep === 6) {
        this.$nextTick(() => {
          privatePayRequestSubmission.initGoogleAutocomplete();
        });
      }
      if (newStep === 5 && this.$data.selectedService === 'interpretation' && this.$data.interpretationMode === 'In-Person') {
        this.$nextTick(() => {
          privatePayRequestSubmission.initFacilityGoogleAutocomplete();
        });
      }
      if (newStep === 6 && this.$data.selectedService === 'interpretation' && this.$data.interpretationMode !== 'In-Person'
        && privatePayRequestSubmission.selectedTimezone) {
        privatePayRequestSubmission.timezone = privatePayRequestSubmission.selectedTimezone.value;
        this.$nextTick(() => {
          privatePayRequestSubmission.initFacilityGoogleAutocomplete();
        });
      }
      if (newStep > oldStep) {
        this.$nextTick(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
    underAnesthesia() {
      const privatePayRequestSubmission = this as PrivatePayRequestSubmission;
      privatePayRequestSubmission.updateRideshareOptIn();
    },
    patientNeedsAssistance() {
      const privatePayRequestSubmission = this as PrivatePayRequestSubmission;
      privatePayRequestSubmission.updateRideshareOptIn();
    },
    interpretationMode(newVal: string) {
      const privatePayRequestSubmission = this as PrivatePayRequestSubmission;

      if (
        this.$data.step === 5 &&
        this.$data.selectedService === 'interpretation' &&
        newVal === 'In-Person'
      ) {
        this.$nextTick(() => {
          privatePayRequestSubmission.initFacilityGoogleAutocomplete();
        });
      }
    },
    tripType(newVal: string) {
      if (newVal === 'oneWay') {
        this.$data.appointmentDuration = '';
        this.$data.waitInLobby = null;
      }
    },
    selectedService(newVal: string, oldVal: string) {
      const privatePayRequestSubmission = this as PrivatePayRequestSubmission;
      if (newVal !== oldVal) {
        if (newVal === 'interpretation') {
          privatePayRequestSubmission.resetTransportationSteps();
        } else if (newVal === 'transportation') {
          privatePayRequestSubmission.resetInterpretationSteps();
        }
      }
    },
    isWithCaregiver(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$data.wantsTransporterCaregiver = null;
      }
    },
    wantsTransporterCaregiver(newVal, oldVal) {
      const privatePayRequestSubmission = this as PrivatePayRequestSubmission;
      privatePayRequestSubmission.updateMentalHealth();
      privatePayRequestSubmission.checkVisitType();
    },
    additionalConsiderations(newVal, oldVal) {
      const privatePayRequestSubmission = this as PrivatePayRequestSubmission;
      privatePayRequestSubmission.updateMentalHealth();
      privatePayRequestSubmission.checkVisitType();
    },
    willingToOptInRideshare() {
      const privatePayRequestSubmission = this as PrivatePayRequestSubmission;
      privatePayRequestSubmission.checkVisitType();
    },
    vehicleType(newType, oldType) {
      if (newType !== oldType) {
        this.$data.patientNeedsAssistance = null;
        this.$data.willingToOptInRideshare = null;
        this.$data.customerHasOwnWheelchair = null;
        this.$data.patient.patientHeight.feet = '';
        this.$data.patient.patientHeight.inch = '';
        this.$data.patient.patientWeight = '';
        this.$data.isWithCaregiver = null;
        this.$data.wantsTransporterCaregiver = null;
        const privatePayRequestSubmission = this as PrivatePayRequestSubmission;
        privatePayRequestSubmission.checkVisitType();
      }
      if (newType === 'Sedan') {
        this.$data.additionalConsiderations = this.$data.additionalConsiderations.filter(
          (option: any) => option !== 'Is traveling in a motorized wheelchair or scooter',
        );
      }
    },
  },
  validations() {
    const validations = {
      fullName: {
        required,
        regex: (fullName: string) => /^[a-zA-Z ]+$/.test(fullName),
      },
      email: {
        required,
        email,
      },
      phone: {
        required,
        minLength: minLength(10),
        regex: (phone: any) => MedTransGoConstants.PHONE_REGX.test(phone),
      },
      passengerName: {
        required,
        regex: (passengerName: string) => /^[a-zA-Z ]+$/.test(passengerName),
      },
      passengerPhone: {
        required,
        minLength: minLength(10),
        regex: (passengerPhone: any) => MedTransGoConstants.PHONE_REGX.test(passengerPhone),
      },
      confirmPassengerPhone: {
        required,
        sameAsPassengerPhone: (value: any) => value === this.$data.passengerPhone,
      },
      patientHeight: {
        feet: {
          required,
        },
        inch: {
          required,
        },
      },
      patientWeight: {
        required,
      },
      pickupAddress: {
        fullAddress: {
          required,
        },
        state: {
          required,
        },
        city: {
          required,
        },
        zip: {
          required,
        },
        pickupInstruction: {
          maxLength: maxLength(100),
        },
        flightsOfStairs: {
          required,
          minValue: minValue(0),
        },
      },
      dropoffAddress: {
        fullAddress: {
          required,
        },
        state: {
          required,
        },
        city: {
          required,
        },
        zip: {
          required,
        },
        dropOffInstruction: {
          maxLength: maxLength(100),
        },
        flightsOfStairs: {
          required,
          minValue: minValue(0),
        },
      },
      facilityAddress: {
        fullAddress: {
          required,
        },
        state: {
          required,
        },
        city: {
          required,
        },
        zip: {
          required,
        },
        dropOffInstruction: {
          maxLength: maxLength(100),
        },
        flightsOfStairs: {
          required,
          minValue: minValue(0),
        },
      },
      additionalNotes: {
        required,
        regex: (additionalNotes: string) => /^[a-zA-Z ]+$/.test(additionalNotes),
      },
      additionalPassengers: {
        required,
        regex: (additionalPassengers: string) => /^[0-9]+$/.test(additionalPassengers),
      },
    };
    return validations;
  },
  computed: {
    formattedTotalWithMarkup(): string {
      if (!this.$data.totalWithMarkup) {
        return '$0.00';
      }
      return MathUtils.formatCurrencyWithoutRound(this.$data.totalWithMarkup);
    },

    formattedStartTime(): string {
      if (!this.$data.startTime || !this.$data.timezone) {
        return '';
      }

      const [hourStr, minuteStr] = this.$data.startTime.split(':');
      let hour = parseInt(hourStr, 10);
      const minute = parseInt(minuteStr, 10);
      const ampm = hour >= 12 ? 'PM' : 'AM';

      hour = hour % 12;
      if (hour === 0) {
        hour = 12;
      }

      const formattedMinute = minute.toString().padStart(2, '0');
      const time = `${hour}:${formattedMinute} ${ampm}`;

      const now = new Date();
      const date = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10),
      );

      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: this.$data.timezone,
        timeZoneName: 'short',
        hour: 'numeric',
      }).formatToParts(date);

      let tzAbbr = '';
      for (const part of parts) {
        if (part.type === 'timeZoneName') {
          tzAbbr = part.value;
          break;
        }
      }
      return `${time} ${tzAbbr}`;
    },
    formattedAppointmentDuration(): string {
      const minutes = Number(this.$data.appointmentDuration);
      if (!minutes) {
        return '';
      }

      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;

      const hourLabel = hours > 0 ? `${hours} hour${hours > 1 ? 's' : ''}` : '';
      const minuteLabel = remainingMinutes > 0 ? `${remainingMinutes} minutes` : '';

      return [hourLabel, minuteLabel].filter(Boolean).join(' ');
    },
    formattedStartDate(): string {
      return DateUtils.formatDate(this.$data.startDate, 'dddd, MMMM D, YYYY');
    },
    visibleAdditionalConsiderationsOptions() {
      if (this.$data.vehicleType === 'Sedan') {
        return this.$data.additionalConsiderationsOptions.filter(
          (option: any) => option !== 'Is traveling in a motorized wheelchair or scooter',
        );
      }
      return this.$data.additionalConsiderationsOptions;
    },
    isStep2Valid() {
      if (!this.$data.selected) {
        return false;
      }
      if (this.$data.selected === 'someone_else') {
        return !this.$v.passengerName.$invalid && !this.$v.passengerPhone.$invalid &&
          !this.$v.confirmPassengerPhone.$invalid;
      }
      return true;
    },
    isStep3Valid() {
      return !!this.$data.selectedService;
    },
    isStep4Valid() {
      if (this.$data.selectedService === 'interpretation') {
        return !!this.$data.preferredLanguage;
      }

      if (!this.$data.vehicleType) {
        return false;
      }
      if ((this.$data.vehicleType === 'Sedan' || this.$data.vehicleType === 'Wheelchair' ||
        this.$data.vehicleType === 'Stretcher') && this.$data.additionalPassengers !== '' &&
        !this.$v.additionalPassengers.regex) {
        return false;
      }
      if (this.$data.vehicleType === 'Sedan') {
        if (this.$data.underAnesthesia === null) {
          return false;
        }
        if (this.$data.underAnesthesia === false && this.$data.patientNeedsAssistance === null) {
          return false;
        }
        if (this.$data.isWithCaregiver === null) {
          return false;
        }
        if (this.$data.isWithCaregiver === false && this.$data.wantsTransporterCaregiver === null) {
          return false;
        }
        return true;
      }
      if (this.$data.vehicleType === 'Wheelchair' || this.$data.vehicleType === 'Stretcher') {
        const { feet, inch } = this.$data.patient.patientHeight;
        if (feet === '' || inch === '' || this.$data.patient.patientWeight === '') {
          return false;
        }
        if (this.$data.vehicleType === 'Wheelchair' && this.$data.customerHasOwnWheelchair === null) {
          return false;
        }
        if (this.$data.isWithCaregiver === null) {
          return false;
        }
        if (this.$data.isWithCaregiver === false && this.$data.wantsTransporterCaregiver === null) {
          return false;
        }
        return true;
      }
      return false;
    },
    isStep5Valid() {
      if (this.$data.tripType === 'roundTrip') {
        return !!this.$data.appointmentDuration && this.$data.waitInLobby !== null;
      }
      return !!this.$data.tripType;
    },
    isStep7Valid(): boolean {
      if (!this.$data.startDate || !this.$data.startTime || (this.$data.tripType === 'roundTrip' &&
        (!this.$data.legBStartTime || !this.$data.isLegBTimeValid))) {
        return false;
      }

      const selectedDateTime = new Date(`${this.$data.startDate}T${this.$data.startTime}`);
      const now = new Date();
      const minAllowedTime = new Date(now.getTime() + 24 * 60 * 60 * 1000); // +24 hours

      return selectedDateTime > minAllowedTime;
    },
    startDateTimeError(): string | null {
      if (!this.$data.startDate || !this.$data.startTime) {
        return null;
      }
      const selectedDateTime = new Date(`${this.$data.startDate}T${this.$data.startTime}`);
      const now = new Date();
      const minAllowedTime = new Date(now.getTime() + 24 * 60 * 60 * 1000);

      if (selectedDateTime <= minAllowedTime) {
        return `Please select a date and time at least 24 hours from now (${minAllowedTime.toLocaleString()})`;
      }

      return null;
    },
    legBPickupTimeError(): string | null {
      const legAStart = this.$data.startTime;
      const legBStart = this.$data.legBStartTime;

      if (!legAStart || !legBStart) {
        return null;
      }

      const [legAHour, legAMin] = legAStart.split(':').map(Number);
      const legAStartDate = new Date();
      legAStartDate.setHours(legAHour, legAMin, 0, 0);

      const [legBHour, legBMin] = legBStart.split(':').map(Number);
      const legBStartDate = new Date();
      legBStartDate.setHours(legBHour, legBMin, 0, 0);

      if (legBStartDate.getTime() <= legAStartDate.getTime()) {
        this.$data.isLegBTimeValid = false;
        return `Leg B pickup time (${legBStart}) must be after Leg A pickup time (${legAStart}).`;
      }
      this.$data.isLegBTimeValid = true;
      return null;
    },

    isStep6Valid() {
      return this.$data.isPickupSelectedFromGoogle && !!this.$data.pickupAddress.fullAddress &&
        this.$data.isDropoffSelectedFromGoogle && !!this.$data.dropoffAddress.fullAddress;
    },
    totalSteps(): number {
      return this.$data.selectedService === 'interpretation' ? 8 : 10;
    },
    isInterpretationStep5Invalid() {
      if (!this.$data.interpretationMode) {
        return false;
      }

      if (this.$data.interpretationMode === 'In-Person') {
        return (
          this.$data.facilityAddress.fullAddress &&
          this.$data.facilityAddress.state && this.$data.isFacilityAddressFromGoogle
        );
      }

      return true; // valid if Video or phone
    },
    isInterpretationStep6Invalid(): boolean {
      const privatePayRequestSubmission = this as PrivatePayRequestSubmission;
      if (!this.$data.startDate || !this.$data.startTime || !this.$data.appointmentDuration ||
        (!privatePayRequestSubmission.selectedTimezone && this.$data.interpretationMode !== 'In-Person')) {
        return true;
      }
      const selectedDateTime = new Date(`${this.$data.startDate}T${this.$data.startTime}`);
      const minAllowedTime = new Date(Date.now() + 24 * 60 * 60 * 1000);
      return selectedDateTime <= minAllowedTime;
    },

    interpretationDateTimeError(): string | null {
      if (!this.$data.startDate || !this.$data.startTime) {
        return null;
      }
      const selectedDateTime = new Date(`${this.$data.startDate}T${this.$data.startTime}`);
      const minAllowedTime = new Date(Date.now() + 24 * 60 * 60 * 1000);

      if (selectedDateTime <= minAllowedTime) {
        return `Please select a date and time at least 24 hours from now (${minAllowedTime.toLocaleString()})`;
      }
      return null;
    },
    totalHeightInInches() {
      const feet = Number(this.$data.patient.patientHeight.feet) || 0;
      const inch = Number(this.$data.patient.patientHeight.inch) || 0;
      return feet * 12 + inch;
    },
  },

})
export default class PrivatePayRequestSubmission extends Vue {
  private otp = ['', '', '', ''];
  private errorMessage = '';
  private otpErrorMessage = '';
  private verifyingOtp = false;
  private otpVerified = false;
  private step = -1;
  private pickupGoogleAddress: any;
  private dropoffGoogleAddress: any;
  private facilityGoogleAddress: any;
  private TimeZones = TimeZones;
  private selectedTimezone: any = null;
  private timezone: string = '';
  private isPaymentSourceValid = false;
  private paymentSource = null;
  private calculatedFare: any;
  private authorizationErrorMessage = '';
  private totalWithMarkup: number = 0;
  private editingTimezone = false;
  private clientSecret = null;
  private finalBufferedFareString = '';
  private originalCost = '';
  private promoCodeDetails: any = null;

  get isStep0Valid() {
    return !this.$v.fullName.$invalid &&
      !this.$v.email.$invalid &&
      !this.$v.phone.$invalid;
  }

  get isTransportationStepCompleted() {
    return (
      this.$data.selectedService === 'transportation' &&
      ['Sedan', 'Wheelchair', 'Stretcher'].includes(this.$data.vehicleType)
    );
  }

  private toggleSubLines(index: any) {
    this.$set(this.$data.showDetails, index, !this.$data.showDetails[index]);
  }


  private onPickupAddressInput() {
    if (this.$data.pickupAddress.fullAddress !== this.$data.pickupAddress.originalGoogleAddress) {
      this.$data.isPickupSelectedFromGoogle = false;
    }
  }

  private onDropoffAddressInput() {
    if (this.$data.dropoffAddress.fullAddress !== this.$data.dropoffAddress.originalGoogleAddress) {
      this.$data.isDropoffSelectedFromGoogle = false;
    }
  }

  private onFacilityAddressInput() {
    if (this.$data.facilityAddress.fullAddress !== this.$data.facilityAddress.originalGoogleAddress) {
      this.$data.isFacilityAddressFromGoogle = false;
    }
  }

  private updateMentalHealth() {
    const hasAtRisk = this.$data.additionalConsiderations
      .includes('Been acknowledged as “at-risk” or a “danger to self or others” by a medical professional within the last month');
    this.$data.mentalHealth = hasAtRisk || this.$data.wantsTransporterCaregiver === true;
  }

  private async resetTransportationSteps() {
    this.$data.vehicleType = '';
    this.$data.tripType = '';
    this.$data.waitInLobby = null;
    this.$data.timezone = '';
    this.selectedTimezone = null;
    this.$data.pickupAddress = {
      fullAddress: '',
      state: '',
      city: '',
      zip: '',
      pickupInstruction: '',
      flightsOfStairs: null,
    };
    this.$data.dropoffAddress = {
      fullAddress: '',
      state: '',
      city: '',
      zip: '',
      dropOffInstruction: '',
      flightsOfStairs: null,
    };
    this.$data.startDate = null;
    this.$data.startTime = '';
    this.$data.startTimeTouched = false;
    this.$data.appointmentDuration = '';
    this.editingTimezone = false;
    this.$data.underAnesthesia = null;
    this.$data.patientNeedsAssistance = null;
    this.$data.willingToOptInRideshare = null;
    this.$data.isWithCaregiver = null;
    this.$data.wantsTransporterCaregiver = null;
  }

  private async resetInterpretationSteps() {
    this.$data.preferredLanguage = '';
    this.$data.interpretationMode = '';
    this.$data.timezone = '';
    this.selectedTimezone = null;
    this.$data.facilityAddress = {
      fullAddress: '',
      state: '',
      city: '',
      zip: '',
      dropOffInstruction: '',
      flightsOfStairs: null,
    };
    this.$data.startDate = null;
    this.$data.startTime = '';
    this.$data.startTimeTouched = false;
    this.$data.appointmentDuration = '';
    this.$data.additionalNotes = '';
    this.editingTimezone = false;
  }

  private async initGoogleAutocomplete() {
    if (!this.$refs.pickupGoogleAddress || !this.$refs.dropoffGoogleAddress) {
      return;
    }
    this.pickupGoogleAddress = new google.maps.places.Autocomplete(
      this.$refs.pickupGoogleAddress,
      { types: ['geocode'] },
    );
    this.pickupGoogleAddress.addListener('place_changed', () => {
      this.$data.pickupAddress = MapUtils.parseGoogleAddress(this.pickupGoogleAddress);
      this.$data.pickupAddress.originalGoogleAddress = this.$data.pickupAddress.fullAddress;
      this.$data.isPickupSelectedFromGoogle = true;
      this.fetchTimezone(this.$data.pickupAddress.latitude, this.$data.pickupAddress.longitude);
    });

    this.dropoffGoogleAddress = new google.maps.places.Autocomplete(
      this.$refs.dropoffGoogleAddress,
      { types: ['geocode'] },
    );
    this.dropoffGoogleAddress.addListener('place_changed', () => {
      this.$data.dropoffAddress = MapUtils.parseGoogleAddress(this.dropoffGoogleAddress);
      this.$data.dropoffAddress.originalGoogleAddress = this.$data.dropoffAddress.fullAddress;
      this.$data.isDropoffSelectedFromGoogle = true;
    });
  }

  private async initFacilityGoogleAutocomplete() {
    if (!this.$refs.facilityGoogleAddress) {
      return;
    }
    this.facilityGoogleAddress = new google.maps.places.Autocomplete(
      this.$refs.facilityGoogleAddress,
      { types: ['geocode'] },
    );

    this.facilityGoogleAddress.addListener('place_changed', () => {
      this.$data.facilityAddress = MapUtils.parseGoogleAddress(this.facilityGoogleAddress);
      this.$data.facilityAddress.originalGoogleAddress = this.$data.facilityAddress.fullAddress;
      this.$data.isFacilityAddressFromGoogle = true;
      this.fetchTimezone(this.$data.facilityAddress.latitude, this.$data.facilityAddress.longitude);
    });
  }

  private async fetchTimezone(lat: number, lng: number) {
    try {
      const timestamp = Math.floor(Date.now() / 1000);
      const apiKey = process.env.VUE_APP_GOOGLE_API_KEY;
      const response = await fetch(
        // tslint:disable-next-line:max-line-length
        `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${apiKey}`,
      );
      const data = await response.json();
      this.timezone = data.timeZoneId;
    } catch (error) {
      console.error('Failed to fetch timezone:', error);
      return null;
    }
  }

  private async handleStep1() {
    if (!this.isStep0Valid) {
      return;
    }
    await this.sendOTP();
    this.step++;
    this.errorMessage = '';
  }

  private async handleStep2() {
    this.step++;
  }
  private async handleStep3() {
    if (!this.$data.languageOptions || this.$data.languageOptions.length === 0) {
      await this.getAllLanguages();
    }
    this.step++;
  }
  private async handleStep4() {
    this.step++;
  }
  private async handleStep5() {
    this.step++;
  }
  private async handleStep6() {
    this.step++;
  }
  private async handleStep7() {
    this.errorMessage = '';
    this.step++;
  }
  private async handleInterpretationStep5() {
    this.errorMessage = '';
    this.$data.selectedInterpretationMode = this.$data.interpretationMode;
    this.step = 6;
  }
  private handleInterpretationStep6() {
    this.errorMessage = '';
    this.step++;
  }

  private async validateTime() {
    if (!this.$data.startTime) {
      // Optionally trigger some error or UI feedback
    }
  }

  private async phoneNumberMask() {
    const replaceInput = this.$data.phone
      .replace(/\D/g, '')
      .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    this.$data.phone = !replaceInput[2]
      ? replaceInput[1]
      : replaceInput[1] +
      '-' +
      replaceInput[2] +
      (replaceInput[3] ? '-' + replaceInput[3] : '');
  }

  private isNumber(evt: KeyboardEvent) {
    const keysAllowed: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
    const keyPressed: string = evt.key;
    if (!keysAllowed.includes(keyPressed)) {
      evt.preventDefault();
    }
  }

  private async passengerPhoneNumberMask() {
    const replaceInput = this.$data.passengerPhone
      .replace(/\D/g, '')
      .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    this.$data.passengerPhone = !replaceInput[2]
      ? replaceInput[1]
      : replaceInput[1] +
      '-' +
      replaceInput[2] +
      (replaceInput[3] ? '-' + replaceInput[3] : '');
  }

  private async confirmPhoneNumberMask() {
    const replaceInput = this.$data.confirmPassengerPhone
      .replace(/\D/g, '')
      .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    this.$data.confirmPassengerPhone = !replaceInput[2]
      ? replaceInput[1]
      : replaceInput[1] +
      '-' +
      replaceInput[2] +
      (replaceInput[3] ? '-' + replaceInput[3] : '');
  }

  private async handleInput(index: number, event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (!/^\d$/.test(value)) {
      this.otp[index] = '';
      return;
    }
    this.otp[index] = value;
    const inputs = this.$refs.otp as HTMLInputElement[];
    // if (inputs[index + 1]) {
    //   inputs[index + 1].focus();
    // }
    if (index < 3 && inputs[index + 1]) {
      inputs[index + 1].focus();
    }
    const isComplete = this.otp.every((digit) => /^\d$/.test(digit));
    if (isComplete) {
      await this.verifyOtpRequest();
    }
  }

  private handleBackspace(index: number, event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const inputs = this.$refs.otp as HTMLInputElement[];
    if (!input.value && index > 0) {
      inputs[index - 1].focus();
    }
  }

  private formatServiceName(service: any) {
    if (!service || typeof service !== 'string') {
      return service;
    }
    const formatedService = service
      .replace(
        /\s*-?\s*(OBH|BH|Business Hours Pricing|Business Hours|Outside of Hours Pricing Business| Outside of Hours|Outside of Business Hours)\b/gi,
        '').replace(/\s{2,}/g, ' ').trim();
    return formatedService || service;
  }


  private async verifyOtpRequest() {
    const iHttpService = ObjectFactory.getHttpService();

    const verifyOtpRequest: any = {
      phoneNumber: this.$data.phone,
      otpCode: this.$data.otp.join(''),
    };

    const apiRequest: ApiRequest = {
      baseURL: this.$store.state.serverUrl,
      url: `${MedTransGoConstants.HTTP_URL_REQUESTS_V2}/privatePay/verifyOTP`,
      data: verifyOtpRequest,
      loaderEvent: {
        show: true,
      },
    };
    const response = await iHttpService.post<any>(apiRequest);
    if (response.success) {
      const toastEvent: ToastEvent = {
        message: 'OTP Verified Successfully.',
        title: 'Success',
        varient: 'success',
        timeout: 5000,
      };
      EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
      this.step++;
      this.otpVerified = true;
      this.otpErrorMessage = '';
    } else {
      this.otpErrorMessage = response.errors ? `Incorrect code. Please try again, or click 'Resend Code' to receive a new code` : 'Invalid Otp';
    }
  }

  private handleUnderAnesthesiaYes() {
    this.$data.underAnesthesia = true;
    this.$data.patientNeedsAssistance = null;
    this.$data.willingToOptInRideshare = false;
    this.$data.isWithCaregiver = null;
    this.$data.wantsTransporterCaregiver = null;
  }

  private async calculateFare() {
    this.$data.isPromoCodeApplied = false;
    this.$data.promoCode = '';
    this.promoCodeDetails = {};
    const iHttpService = ObjectFactory.getHttpService();
    const pickup = this.$data.pickupAddress;
    const dropoff = this.$data.dropoffAddress;
    const facility = this.$data.facilityAddress;
    const startTime = this.$data.startTime;
    const legBStartTime = this.$data.legBStartTime ? this.$data.legBStartTime.substring(0, 5) : '';
    const visitType = this.checkVisitType();
    let isRideshareEligible = visitType === 'Non-Procedure' && this.$data.willingToOptInRideshare === true;
    if (this.$data.tripType === 'roundTrip' && this.$data.waitInLobby) {
       isRideshareEligible = false;
    }
    const payload: any = {
      appointment: {
        date: moment(this.$data.startDate).format('YYYY-MM-DD'),
        time: startTime.substring(0, 5),
        timezone: this.timezone,
        facility: {
          name: '',
          email: '',
          phone: '',
          address: {
            fullAddress: dropoff.fullAddress ? dropoff.fullAddress : facility.fullAddress,
            city: dropoff.city ? dropoff.city : facility.city,
            state: dropoff.state ? dropoff.state : facility.state,
            zip: dropoff.zip ? dropoff.zip : facility.zip,
            country: dropoff.country ? (dropoff.country || 'USA') : (facility.country ? facility.country : 'USA'),
            latitude: dropoff.latitude ? dropoff.latitude : facility.latitude,
            longitude: dropoff.longitude ? dropoff.longitude : facility.longitude,
          },
        },
        patient: {
          fullName: this.$data.selected === 'someone_else' ? this.$data.passengerName : this.$data.fullName,
          email: this.$data.selected === 'someone_else' ? '' : this.$data.email,
          phone: this.$data.selected === 'someone_else' ? this.$data.passengerPhone : this.$data.phone,
          birthdate: '', // Optional: Fill if available
          address: {
            fullAddress: pickup.fullAddress,
            city: pickup.city,
            state: pickup.state,
            zip: pickup.zip,
            country: pickup.country || 'USA',
            latitude: pickup.latitude,
            longitude: pickup.longitude,
          },
          patientHeight: {
            feet: this.$data.patient.patientHeight ? this.$data.patient.patientHeight.feet : null,
            inch: this.$data.patient.patientHeight ? this.$data.patient.patientHeight.inch : null,
          },
          patientWeight: this.$data.patient ? this.$data.patient.patientWeight : null,
          preferredLanguage: this.$data.selectedService === 'interpretation' ?
            this.$data.preferredLanguage : '',
        },
      },
      requestedForSelf: this.$data.selected === 'someone_else' ? false : true,
      requesterDetails: this.$data.selected === 'someone_else' ? {
        fullName: this.$data.fullName,
        email: this.$data.email,
        phone: this.$data.phone,
      } : null,
      transportRequest: {
        legBPickUpTime: legBStartTime,
        vehicleType: this.$data.vehicleType,
        estimatedVisitTime: this.$data.tripType === 'roundTrip'
          ? {
            hours: Math.floor(Number(this.$data.appointmentDuration) / 60),
            minutes: Number(this.$data.appointmentDuration) % 60,
          }
          : {
            hours: 0,
            minutes: 0,
          },
        routes: [
          {
            pickupAddress: {
              fullAddress: pickup.fullAddress,
              city: pickup.city,
              state: pickup.state,
              zip: pickup.zip,
              country: pickup.country || 'USA',
              latitude: pickup.latitude,
              longitude: pickup.longitude,
              apartment: pickup.apartment,
              pickupInstruction: pickup.pickUpInstructions,
            },
            dropoffAddress: {
              fullAddress: dropoff.fullAddress,
              city: dropoff.city,
              state: dropoff.state,
              zip: dropoff.zip,
              country: dropoff.country || 'USA',
              latitude: dropoff.latitude,
              longitude: dropoff.longitude,
              apartment: dropoff.apartment,
              dropOffInstruction: dropoff.dropOffInstructions,
            },
            additionalNotes: this.$data.additionalNotes,
          },
        ],
        conciergeService: this.$data.waitInLobby ? true : false,
        caregiver: this.$data.isWithCaregiver ? true : false,
        mentalHealth: this.$data.mentalHealth,
        rideshareService: isRideshareEligible,
        isBariatricServiceRequired: this.$data.vehicleType !== 'Sedan' && this.$data.patient
          && Number(this.$data.patient.patientWeight) >= 300 ? true : false,
        visitType: this.checkVisitType(),
        transport: this.$data.vehicleType as string,
        underAnesthesia: this.$data.underAnesthesia,
        additionalConsiderations: this.$data.additionalConsiderations,
        additionalPassengers: this.$data.additionalPassengers,
        timescope: 'Pickup',
        isOxygenTankRequired: this.$data.additionalConsiderations.includes('Has an oxygen tank or other heavy medical equipment'),
        isWheelchairProvided: this.$data.customerHasOwnWheelchair,
      },
      interpretationRequest: {
        estimatedTime: {
          hours: Math.floor(Number(this.$data.appointmentDuration) / 60),
          minutes: Number(this.$data.appointmentDuration) % 60,
        },
        serviceType: this.$data.interpretationMode === 'phone' ? 'Phone' : this.$data.interpretationMode,
        additionalNotes: this.$data.additionalNotes,
        language: this.$data.preferredLanguage,
      },
    };
    if (payload.transportRequest && this.$data.tripType && this.$data.tripType === 'roundTrip') {
      payload.transportRequest.routes.push({
        pickupAddress: payload.transportRequest.routes[0].dropoffAddress,
        dropoffAddress: payload.transportRequest.routes[0].pickupAddress,
        additionalNotes: this.$data.additionalNotes,
      });
    }
    if (this.$data.selectedService === 'transportation') {
      delete payload.interpretationRequest;
      if (this.$data.vehicleType === 'Sedan') {
        if (visitType === 'Procedure') {
          payload.transportRequest.transport = 'Ambulatory (Procedure)';
        } else {
          payload.transportRequest.transport = 'Ambulatory (Non-Procedure)';
        }
      }
    } else {
      if (this.$data.interpretationMode !== 'In-Person') {
        delete payload.appointment.facility.address;
      }
      delete payload.appointment.patient.address;
      delete payload.transportRequest;
    }

    const apiRequest: ApiRequest = {
      baseURL: this.$store.state.serverUrl,
      url: `${MedTransGoConstants.HTTP_URL_REQUESTS_V2}/privatePay/calculateFare`,
      data: payload,
      loaderEvent: {
        show: true,
      },
    };
    const response = await iHttpService.post<any>(apiRequest);
    if (response.success && response.data) {
      this.clientSecret = response.data.stripePaymentSession;
      this.calculatedFare = response.data.fare;
      let serviceFee = 0;
      this.calculatedFare.details.lines.forEach((line: any) => {
        if (line.subLines) {
          line.subLines.forEach((sub: any) => {
            if (sub.description === 'Service Fee') {
              serviceFee += parseFloat(sub.amount.replace(/[^0-9.-]+/g, ''));
            }
          });
        }
      });
      this.calculatedFare.details.lines = this.calculatedFare.details.lines.map((line: any) => {
        const rawSubtotal = parseFloat(line.subTotal.replace(/[^0-9.-]+/g, ''));
        let adjustedSubtotal = rawSubtotal;

        if (!line.service.includes('Leg B')) {
          adjustedSubtotal = rawSubtotal - serviceFee;
        }
        return {
          ...line,
          adjustedSubTotal: adjustedSubtotal,
          adjustedSubTotalString: adjustedSubtotal.toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        };
      });
      const particulars = this.calculatedFare.particulars;
      const finalBufferedFare = MathUtils.calculateTotal(particulars);
      this.finalBufferedFareString = MathUtils.formatCurrencyWithoutRound(finalBufferedFare);
      this.originalCost = this.finalBufferedFareString;
      this.totalWithMarkup = finalBufferedFare * 1.2;
      this.$data.step++;
    } else {
      this.errorMessage = CommonUtils.translateErrorCode(response.errorCode);
    }

  }

  private async getAllLanguages() {
    const iHttpService = ObjectFactory.getHttpService();
    const apiRequest: ApiRequest = {
      baseURL: this.$store.state.serverUrl,
      url: `${MedTransGoConstants.HTTP_URL_REQUESTS_V2}/privatePay/language`,
      loaderEvent: {
        show: true,
      },
    };
    const response = await iHttpService.get<Language[]>(apiRequest);
    if (response.success && response.data) {
      response.data.forEach((language) => {
        const option = {
          value: language.name,
          text: language.name,
        };
        this.$data.languageOptions.push(option);
      });
    }
  }

  private redirectToMTGWebsite() {
    location.href = 'http://www.accessbymedtransgo.com';
  }

  private async resendCode() {
    this.sendOTP();
  }

  private checkVisitType() {
    const wantsCaregiver = this.$data.wantsTransporterCaregiver === true;
    const hasConsiderations =
      this.$data.additionalConsiderations &&
      this.$data.additionalConsiderations.length > 0;
    const isSpecialVehicle =
      this.$data.vehicleType === 'Wheelchair' || this.$data.vehicleType === 'Stretcher';

    if (this.$data.willingToOptInRideshare === true && !wantsCaregiver
      && !hasConsiderations && !isSpecialVehicle) {
      return 'Non-Procedure';
    } else {
      return 'Procedure';
    }
  }

  private updateRideshareOptIn() {
    if (this.$data.underAnesthesia === false && this.$data.patientNeedsAssistance === false) {
      this.$data.willingToOptInRideshare = true;
    } else if (this.$data.patientNeedsAssistance === true) {
      this.$data.willingToOptInRideshare = false;
    }
  }

  private async handlePayment(event: any) {
    const paymentIntentID = event.id as string;
    const iHttpService = ObjectFactory.getHttpService();

    const pickup = this.$data.pickupAddress;
    const dropoff = this.$data.dropoffAddress;
    const facility = this.$data.facilityAddress;
    const startTime = this.$data.startTime;
    const legBStartTime = this.$data.legBStartTime ? this.$data.legBStartTime.substring(0, 5) : '';
    const visitType = this.checkVisitType();
    let isRideshareEligible = visitType === 'Non-Procedure' && this.$data.willingToOptInRideshare === true;
    if (this.$data.tripType === 'roundTrip' && this.$data.waitInLobby) {
       isRideshareEligible = false;
    }
    const payload: any = {
      appointment: {
        date: moment(this.$data.startDate).format('YYYY-MM-DD'),
        time: startTime.substring(0, 5),
        timezone: this.timezone,
        facility: {
          name: '',
          email: '',
          phone: '',
          address: {
            fullAddress: dropoff.fullAddress ? dropoff.fullAddress : facility.fullAddress,
            city: dropoff.city ? dropoff.city : facility.city,
            state: dropoff.state ? dropoff.state : facility.state,
            zip: dropoff.zip ? dropoff.zip : facility.zip,
            country: dropoff.country ? (dropoff.country || 'USA') : (facility.country ? facility.country : 'USA'),
            latitude: dropoff.latitude ? dropoff.latitude : facility.latitude,
            longitude: dropoff.longitude ? dropoff.longitude : facility.longitude,
          },
        },
        patient: {
          fullName: this.$data.selected === 'someone_else' ? this.$data.passengerName : this.$data.fullName,
          email: this.$data.selected === 'someone_else' ? '' : this.$data.email,
          phone: this.$data.selected === 'someone_else' ? this.$data.passengerPhone : this.$data.phone,
          birthdate: '', // Optional: Fill if available
          address: {
            fullAddress: pickup.fullAddress,
            city: pickup.city,
            state: pickup.state,
            zip: pickup.zip,
            country: pickup.country || 'USA',
            latitude: pickup.latitude,
            longitude: pickup.longitude,
          },
          patientHeight: {
            feet: this.$data.patient.patientHeight ? this.$data.patient.patientHeight.feet : null,
            inch: this.$data.patient.patientHeight ? this.$data.patient.patientHeight.inch : null,
          },
          patientWeight: this.$data.patient ? this.$data.patient.patientWeight : null,
          preferredLanguage: this.$data.selectedService === 'interpretation' ?
            this.$data.preferredLanguage : '',
        },
      },
      requestedForSelf: this.$data.selected === 'someone_else' ? false : true,
      requesterDetails: this.$data.selected === 'someone_else' ? {
        fullName: this.$data.fullName,
        email: this.$data.email,
        phone: this.$data.phone,
      } : null,
      isPromoCodeApplied: this.$data.isPromoCodeApplied ? this.$data.isPromoCodeApplied : false,
      promoCode: this.promoCodeDetails ?  this.promoCodeDetails : {},
      transportRequest: {
        legBPickUpTime: legBStartTime,
        vehicleType: this.$data.vehicleType,
        estimatedVisitTime: this.$data.tripType === 'roundTrip'
          ? {
            hours: Math.floor(Number(this.$data.appointmentDuration) / 60),
            minutes: Number(this.$data.appointmentDuration) % 60,
          }
          : {
            hours: 0,
            minutes: 0,
          },
        routes: [
          {
            pickupAddress: {
              fullAddress: pickup.fullAddress,
              city: pickup.city,
              state: pickup.state,
              zip: pickup.zip,
              country: pickup.country || 'USA',
              latitude: pickup.latitude,
              longitude: pickup.longitude,
              apartment: pickup.apartment,
              pickupInstruction: pickup.pickUpInstructions,
            },
            dropoffAddress: {
              fullAddress: dropoff.fullAddress,
              city: dropoff.city,
              state: dropoff.state,
              zip: dropoff.zip,
              country: dropoff.country || 'USA',
              latitude: dropoff.latitude,
              longitude: dropoff.longitude,
              apartment: dropoff.apartment,
              dropOffInstruction: dropoff.dropOffInstructions,
            },
          },
        ],
        conciergeService: this.$data.waitInLobby ? true : false,
        caregiver: this.$data.isWithCaregiver ? true : false,
        mentalHealth: this.$data.mentalHealth,
        rideshareService: isRideshareEligible,
        isBariatricServiceRequired: this.$data.vehicleType !== 'Sedan' && this.$data.patient
          && Number(this.$data.patient.patientWeight) >= 300 ? true : false,
        visitType: this.checkVisitType(),
        transport: this.$data.vehicleType as string,
        underAnesthesia: this.$data.underAnesthesia,
        additionalConsiderations: this.$data.additionalConsiderations,
        additionalPassengers: this.$data.additionalPassengers,
        timescope: 'Pickup',
        isOxygenTankRequired: this.$data.additionalConsiderations.includes('Has an oxygen tank or other heavy medical equipment'),
        isWheelchairProvided: this.$data.customerHasOwnWheelchair,
      },
      interpretationRequest: {
        estimatedTime: {
          hours: Math.floor(Number(this.$data.appointmentDuration) / 60),
          minutes: Number(this.$data.appointmentDuration) % 60,
        },
        serviceType: this.$data.interpretationMode === 'phone' ? 'Phone' : this.$data.interpretationMode,
        language: this.$data.preferredLanguage,
      },
      additionalNotes: this.$data.additionalNotes,
    };
    if (payload.transportRequest && this.$data.tripType && this.$data.tripType === 'roundTrip') {
      payload.transportRequest.routes.push({
        pickupAddress: payload.transportRequest.routes[0].dropoffAddress,
        dropoffAddress: payload.transportRequest.routes[0].pickupAddress,
      });
    }
    if (this.$data.selectedService === 'transportation') {
      delete payload.interpretationRequest;
      if (this.$data.vehicleType === 'Sedan') {
        if (visitType === 'Procedure') {
          payload.transportRequest.transport = 'Ambulatory (Procedure)';
        } else {
          payload.transportRequest.transport = 'Ambulatory (Non-Procedure)';
        }
      }
    } else {
      if (this.$data.interpretationMode !== 'In-Person') {
        delete payload.appointment.facility.address;
      }
      delete payload.appointment.patient.address;
      delete payload.transportRequest;
    }

    const apiRequest: ApiRequest = {
      baseURL: this.$store.state.serverUrl,
      url: `${MedTransGoConstants.HTTP_URL_REQUESTS_V2}/privatePay/processPayment`,
      data: {
        chargePrivatePaymentRequest: {
          amount: this.totalWithMarkup,
          paymentIntentID,
        }, request: payload,
      },
      loaderEvent: {
        show: true,
      },
    };
    const response = await iHttpService.post<any>(apiRequest);
    if (response.success) {
      posthog.capture('payment_success', {
        amount: this.totalWithMarkup,
        paymentIntentID,
      });
      const toastEvent: ToastEvent = {
        message: 'Request Submitted Successfully.',
        title: 'Success',
        varient: 'success',
        timeout: 5000,
      };
      EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
      const messageBox = this.$refs.messageBox as any;
      if (messageBox && typeof messageBox.showModal === 'function') {
        messageBox.showModal();
      }
    } else {
      this.authorizationErrorMessage = CommonUtils.translateErrorCode(response.errorCode);
    }

  }

  private async sendOTP() {
    const iHttpService = ObjectFactory.getHttpService();

    const sentOtpRequest: any = {
      phoneNumber: this.$data.phone,
    };

    const apiRequest: ApiRequest = {
      baseURL: this.$store.state.serverUrl,
      url: `${MedTransGoConstants.HTTP_URL_REQUESTS_V2}/privatePay/sendOTP`,
      data: sentOtpRequest,
      loaderEvent: {
        show: true,
      },
    };
    const response = await iHttpService.post<any>(apiRequest);
    if (response.success) {
      posthog.capture('otp_sent_success', {
        sentOtpRequest,
      });
      const toastEvent: ToastEvent = {
        message: 'OTP Send Successfully.',
        title: 'Success',
        varient: 'success',
        timeout: 5000,
      };
      EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
      this.errorMessage = null as any;
    } else {
      this.errorMessage = CommonUtils.translateErrorCode(response.errorCode);
    }
  }

  private saveCreditCard(creditCard: any) {
    this.isPaymentSourceValid = (creditCard.cardHolderName && creditCard.cardToken);
    if (this.isPaymentSourceValid) {
      this.paymentSource = creditCard.cardToken.token.id;
    } else {
      this.paymentSource = null;
    }
  }

  private setTimezone(timezone: any) {
    this.timezone = timezone.value;
  }

  private async applyCode() {
    if (!this.$data.isPromoCodeApplied) {
      const iHttpService = ObjectFactory.getHttpService();
      const promoCodeRequest: any = {
        fare: this.calculatedFare,
        code: this.$data.promoCode,
      };

      const apiRequest: ApiRequest = {
        baseURL: this.$store.state.serverUrl,
        url: `${MedTransGoConstants.HTTP_URL_REQUESTS_V2}/privatePay/applyCode`,
        data: promoCodeRequest,
        loaderEvent: {
          show: true,
        },
      };
      const response = await iHttpService.post<any>(apiRequest);
      if (response.success && response.data) {
        this.clientSecret = response.data.stripePaymentSession;
        this.calculatedFare = response.data.fare;
        this.$data.isPromoCodeApplied = this.calculatedFare.isPromoCodeApplied;
        this.promoCodeDetails = this.calculatedFare.details.promoCode;
        const particulars = this.calculatedFare.particulars;
        const finalBufferedFare = MathUtils.calculateTotal(particulars);
        this.finalBufferedFareString = MathUtils.formatCurrencyWithoutRound(finalBufferedFare);
        this.totalWithMarkup = finalBufferedFare * 1.2;
        const toastEvent: ToastEvent = {
          message: 'Code Applied Successfully.',
          title: 'Success',
          varient: 'success',
          timeout: 5000,
        };
        EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        this.errorMessage = null as any;
      } else {
          this.errorMessage = response.errorCode ? 'This code is not valid. Please try again.' : '';
      }
      this.$data.promoCode = '';
    }
  }

  private getUpdatedDescription(description: string): string {
    if (description.startsWith('Base Charge')) {
        return description.replace('free ', '');
    }
    switch (description) {
      case 'Mental Health Surcharge':
      return 'Transporter-Provided Caregiver';
      case 'Oxygen Tank Surcharge':
        return 'Oxygen Tank Handling';
      case 'Additional Passenger Surcharge':
        return 'Additional Passenger';
      default:
        return description;
    }
  }

}
